
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input
} from '../ui/ot'
import { Label } from "../ui/label"

const FolderForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}

}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
        if (name.includes('language_culture_value')) {
            setCount(count + 1);
        }
    };

    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        console.log({ field });
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                form={form}
                                count={count}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    form,
    count
}) => {
    function removeLastFolder(path) {
        if (!path) return path;
        // 用 "/" 分割，過濾掉空字串（避免第一個 "/" 造成的空）
        const parts = path.split("/").filter(Boolean);
        // 去掉最後一個
        parts.pop();
        // 再組合回來，加上 "/" 開頭
        return "/" + parts.join("/");
    }
    const getPath = (name, count) => {
        let fullName = [...name, 'path'];
        let route1 = form.getFieldValue(fullName) || '';
        let newRoute = removeLastFolder(route1);
        let nameFullName = [...name, 'name_language_data'];
        let name_language_data = form.getFieldValue(nameFullName) || [];
        let nameTw = name_language_data?.find((e) => e?.language_culture_code === 'zh-tw')?.language_culture_value || '';
        return newRoute + '/' + nameTw;
    }
    return (
        <Row>
            <Col span={24} >
                {/* 資料夾名稱 */}
                <Col span={24}>
                    <Form.List
                        {...field}
                        name={[field?.name, 'name_language_data']}>
                        {(subfields, { add, remove }) => <>
                            {subfields.map((subfield, index) => <>
                                <Row  >
                                    <Col span={24}>
                                        <Form.Item
                                            labelCol={24}
                                            wrapperCol={24}
                                            label="語言代碼"
                                            name={[subfield?.name, "language_culture_code"]}
                                            hidden={true}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            labelCol={24}
                                            wrapperCol={24}
                                            label="資料夾名稱"
                                            name={[subfield?.name ?? '', 'language_culture_value']}
                                            rules={[{ required: true, message: '請輸入資料夾名稱' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>)}
                        </>}
                    </Form.List>
                </Col>
            </Col>
            <Col span={24} >
                <Form.List
                    {...field}
                    name={[field.name, 'folder_classify_structure_type_data']}
                >
                    {(subfields, { add, remove }) => (
                        <Row>
                            {subfields.map((subfield) => (
                                <Col span={24} key={subfield.key}>
                                    <Row  >
                                        <Col span={24} >
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                label="folder_id"
                                                name={[subfield.name ?? '', 'folder_id']}
                                                hidden={true}
                                            >
                                                {/* <Input /> */}

                                            </Form.Item>
                                        </Col>
                                        <Col span={24} >
                                            <Form.Item
                                                labelCol={24}
                                                wrapperCol={24}
                                                {...subfield}
                                                name={[subfield?.name ?? '', 'folder_classify_structure_type_id']}
                                                fieldKey={[subfield?.fieldKey ?? '', 'folder_classify_structure_type_id']}
                                                label="folder_classify_structure_type_id"
                                                hidden={true}
                                            >
                                            </Form.Item>
                                        </Col>
                                        <Col span={24} >
                                            <Form.Item
                                                labelCol={24}
                                                wrapperCol={24}
                                                {...subfield}
                                                name={[subfield?.name ?? '', 'classify_structure_id']}
                                                fieldKey={[subfield?.fieldKey ?? '', 'classify_structure_id']}
                                                label="classify_structure_id"
                                                hidden={true}
                                            >

                                            </Form.Item>
                                        </Col>
                                        <Col span={24} >
                                            <Form.Item
                                                labelCol={24}
                                                wrapperCol={24}
                                                {...subfield}
                                                name={[subfield?.name ?? '', 'classify_structure_type_id']}
                                                fieldKey={[subfield?.fieldKey ?? '', 'classify_structure_type_id']}
                                                label="classify_structure_type_id"
                                                hidden={true}
                                            >

                                            </Form.Item>
                                        </Col>



                                        <Col span={24}>
                                            <Form.Item
                                                {...subfield}
                                                labelCol={24}
                                                wrapperCol={24}
                                                label="說明"
                                                name={[subfield?.name ?? '', 'description']}
                                                rules={[{ required: true, message: '請輸入資料夾說明' }]}
                                                fieldKey={[subfield?.fieldKey ?? '', 'description']}

                                            >
                                                <Input.TextArea />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            ))}
                        </Row>
                    )}
                </Form.List>
            </Col>

            <Col span={24}>
                <div className="space-y-4">
                    <div className="p-3 bg-gray-50 rounded-lg">
                        <Label className="text-sm font-medium text-gray-700">路徑預覽</Label>
                        <div className="mt-1 font-mono text-xs text-gray-600">
                            {getPath([field?.name], count)}
                        </div>
                    </div>
                </div>
            </Col>

        </Row>
    );
};
export default FolderForm;
